<template>
  <div>
    <div class='flex-sb'>
      <div>
        <el-form :inline='true' size='small'>
          <el-form-item style='width: 100%'>
            <PlatformsRadioGroup :showAll='true' :platformCode='searchCondition.platform_code'
                                 @choicePlatform='choicePlatform'></PlatformsRadioGroup>
          </el-form-item>
          <el-form-item>
            <CompanySelect ref='refCompanySelect' :multiple='true' @handleSelect='selectDept' />
          </el-form-item>
          <el-form-item>
            <el-date-picker
              v-model='ym'
              type='month'
              format='yyyy年MM月'
              value-format='yyyy-MM'
              placeholder='选择月度' style='width: 140px' @change='changeMonth'>
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-popover
              placement='right'
              title=''
              width='500'
              trigger='click'
            >
              <el-button size='small' type='primary' slot='reference'>
                选择季度<span v-if='quarter.label'>: {{ quarter.label }}</span>
              </el-button>
              <el-row>
                <el-col :span='24'>
                  <el-radio-group v-model='quarter' @change='changeQuarter'>
                    <el-radio-button v-for='(quarter) in quarters' :label='quarter' :key='quarter.label'>
                      {{ quarter.label }}
                    </el-radio-button>
                  </el-radio-group>
                </el-col>
              </el-row>
            </el-popover>
          </el-form-item>
          <el-form-item>
            <el-date-picker
              v-model='year'
              type='year'
              format='yyyy年'
              value-format='yyyy'
              placeholder='选择年度' style='width: 140px' @change='changeYear'>
            </el-date-picker>
          </el-form-item>
          <el-form-item label=''>
            <el-select v-model='filterArtist' filterable multiple collapse-tags placeholder='检索红人' clearable>
              <el-option
                v-for='item in tableData'
                :key='item.artist_id'
                :label='item.nickname'
                :value='item.artist_id'>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-tooltip effect='dark' content='有临时权限且系统判定在公司内，可查看所有组数据，请注意数据保密！！！'
                        placement='top-start'
                        v-if="userPermissions.indexOf('temp_rv') !== -1">
              <span><i v-if='in_company' class='el-icon-location-outline'
                       style='color: #E6A23C;font-size: 18px'></i></span>
            </el-tooltip>
          </el-form-item>
          <el-form-item>
            <el-button type='primary' @click='initData' icon='el-icon-search' :loading='loading' :disabled='loading'>搜索</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div style='position: absolute;right: 20px;padding: 10px;z-index: 9999;opacity: 90%;background-color: white'>
        <export-link ref='refExportLink' @export='exportExcel' class-name='export-excel'
                     :can-export="userPermissions.indexOf('dashboard_revenue_export') !== -1"
                     :lint-title='`导出表格`'></export-link>
        <ImageShare v-if="userPermissions.indexOf('dashboard_revenue_share') !== -1" :share-content-id='`shareContent`'
                    :btn-title='`分享榜单`' :dialog-title='`营收榜单分享图`' />
        <el-link :underline='true' type='primary' class='share-rank' @click='goTrendDataList'
                 v-if="userPermissions.indexOf('revenue_data') !== -1"><i class='el-icon-s-grid'></i>详情
        </el-link>
        <el-tooltip class='item' effect='dark' content='无权限：查看营收数据列表' placement='left-start' v-else>
          <el-link :underline='false' type='info' class='export-excel'>
            <i class='el-icon-s-grid'></i>详情
          </el-link>
        </el-tooltip>
      </div>
    </div>

    <!--    表格-->
    <div id='shareContent'>
      <div class='default-table' id='my-rank'
           v-loading='loading'
           element-loading-text='数据加载中……'
           element-loading-spinner='el-icon-loading'>
        <el-table
          :data='tableData'
          :default-sort="{prop:'income_total', order:'descending'}"
          :row-class-name='rowClassName'
          :summary-method='getSummaries'
          show-summary
          border
          style='width: 100%'>
          <el-table-column
            prop='index'
            width='64'
            label='序号' align='center' fixed='left'>
          </el-table-column>
          <el-table-column
            prop='group_name'
            label='部门-组'
            width='200' align='center' sortable>
            <template slot-scope='{row}'>
              <el-link type='primary' @click='goDeptDetail(row.group_id)'
                       v-if="userPermissions.indexOf('dept_detail')>-1"
                       target='_blank'>
                {{ row.group_name || '' }}
              </el-link>
              <span v-else>{{ row.group_name || '' }}</span>

            </template>
          </el-table-column>
          <el-table-column
            prop='nickname'
            label='红人昵称'
            width='160' show-overflow-tooltip align='center' header-align='center'>
            <template slot-scope='{row}'>
              <el-link :underline='true' type='primary' @click='jumpToKolDetail(row.artist_id)' title='点击查看【红人详情】'>
                {{ row.nickname }}
              </el-link>
              <span style='color: #F56C6C' :title='`${$utils.parseTime(row.fired_at,"{y}-{m}-{d}")}`'>
                {{ row.sign_status === 'N' ? '『解约』' : '' }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop='duration'
            label='合作时长'
            min-width='100' align='center' sortable>
            <template slot-scope='scope'>
              <el-tooltip class='item' effect='dark'
                          :content="`签约时间：${scope.row.sign_date?$utils.parseTime(scope.row.sign_date, '{y}/{m}/{d}'):''}`"
                          placement='top'>
                <span>{{ scope.row.duration_alias }}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop='income_total'
            label='总营收'
            sortable
            min-width='100' align='right' header-align='center'>
            <template slot-scope='scope'>
              {{ moneyFormat(scope.row.income_total || 0) }}
            </template>
          </el-table-column>
          <el-table-column
            align='right'
            header-align='center'
            label='保量收入'
            min-width='100' prop='income_8' sortable>
            <template slot-scope='scope'>
              {{ moneyFormat(scope.row.income_8 || 0) }}
            </template>
          </el-table-column>
          <el-table-column
            prop='income_1'
            sortable
            :label='`商务营收`'
            min-width='120' align='right' header-align='center'>
            <template slot-scope='scope'>
              {{ moneyFormat(scope.row.income_1 || 0) }}
            </template>
          </el-table-column>
          <template v-for='(column,index) in columns'>
            <el-table-column :prop='`${column.value}`' :key='index' :label='`${column.title}`'
                             :min-width='`${column.width}`' align='right' header-align='center' sortable>
              <template slot-scope='scope'>
                <span>{{ moneyFormat(scope.row[column.value] || 0) }}</span>
              </template>
            </el-table-column>
          </template>
        </el-table>
      </div>
    </div>

    <!--    备注-->
    <RevenueTips/>

    <DetailsDrawer :drawerTitle='drawerTitle' :drawerTableData='drawerTableData'
                   :drawerVisible.sync='drawerVisible'></DetailsDrawer>
  </div>
</template>

<script>
import FileSaver from 'file-saver'
import {mapGetters} from 'vuex'
import {numberFormat} from '@/utils/utils'
import DetailsDrawer from '@/components/DetailsDrawer'
import PlatformsRadioGroup from '@/pages/platform/components/PlatformsRadioGroup'
import ExportLink from '@/components/export/ExportLink'
import RevenueTips from '@/pages/revenue/RevenueTips'

export default {
  name: 'RevenueRank',
  components: { RevenueTips, ExportLink, PlatformsRadioGroup, DetailsDrawer },
  data() {
    return {
      tipsList: [
        '总营收 = 保量收入 + 商务营收 + 短视频佣金 + 商品销售利润  + 直播佣金 + 坑位费/线下结佣 + 商品销售利润',
        '当期盈亏 = 当期总营收 - 当期总推广花费',
        '平均单价 = 商务营收 / 执行商单数'
      ],
      loading: false,
      income_types: [
        { id: 8, name: '保量收入' },
        { id: 1, name: '商务营收' },
        { id: 2, name: '执行商单数' },
        { id: 3, name: '短视频佣金' },
        { id: 4, name: '直播佣金' },
        { id: 5, name: '坑位费/线下结佣' },
        // { id: 6, name: '授权收入' },
        { id: 7, name: '推广花费' }
      ],
      conditionStr: '',
      searchCondition: {
        depth: null,
        // group_id: null,
        group_range: null,
        year: null,
        platform_code: '',
        months: []
      },
      year: null,
      ym: null,
      rangYm: null,
      quarter: { label: '', value: [] },
      quarters: [
        { label: '暂时不选', value: [] },
        { label: '第一季度', value: [1, 2, 3] },
        { label: '第二季度', value: [4, 5, 6] },
        { label: '第三季度', value: [7, 8, 9] },
        { label: '第四季度', value: [10, 11, 12] }
      ],
      tableData: [],
      platforms: [],
      checkAll: false,
      checkedPlatforms: [],
      isIndeterminate: true,
      columns: [
        // {value: 'income_total', title: '总营收', width: 100},
        // {value: 'income_1', title: '商务营收', width: 100},
        // { value: 'order_count', title: '执行商单数(同步)', width: 120 },
        { value: 'income_2', title: '执行商单数', width: 100 },
        { value: 'avg_price', title: '平均单价', width: 100 },
        { value: 'income_3', title: '短视频佣金', width: 100 },
        { value: 'income_4', title: '直播佣金', width: 100 },
        { value: 'income_5', title: '坑位费/线下结佣', width: 100 },
        { value: 'income_9', title: '商品销售利润', width: 100 },
        // { value: 'income_6', title: '授权收入', width: 100 },
        { value: 'income_7', title: '总推广花费', width: 100 },
        { value: 'income_balance', title: '当期盈亏', width: 100 }
      ],
      lastDate: '',
      pickerOptions: {
        shortcuts: [{
          text: '本月',
          onClick(picker) {
            picker.$emit('pick', [new Date(), new Date()])
          }
        }, {
          text: '今年至今',
          onClick(picker) {
            const end = new Date()
            const start = new Date(new Date().getFullYear(), 0)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近六个月',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setMonth(start.getMonth() - 6)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      filterArtist: [],
      filterGroups: [],//过滤分组
      in_company: false,//是否在公司
      drawerVisible: false,
      drawerTableData: [],
      drawerTitle: '订单详情'

    }
  },
  computed: {
    ...mapGetters(['userPermissions', 'buttonType'])
  },
  created() {
    this.getLastMonth()
    this.getPlatforms()
  },
  mounted() {
    this.initData()
  },
  methods: {
    async init() {
      await this.getLastMonth()
      await this.getPlatforms()
      await this.initData()
    },
    rowDblclick() {
    },
    rowClassName({ row, rowIndex }) {
      // 把每一行的索引放进row.id
      row.index = rowIndex + 1

      row.isShow = this.filterArtist && this.filterArtist.length > 0 ? this.filterArtist.indexOf(row.artist_id) > -1 : true
      if (!row.isShow) {
        return 'hidden-columns'//table.css
      }

      row.isShow = this.filterGroups && this.filterGroups.length > 0 ? this.filterGroups.indexOf(row.group_id) > -1 : true
      if (!row.isShow) {
        return 'hidden-columns'//table.css
      }

      if (row.is_empty) {
        return 'warning-row'
      } else if (rowIndex === 3) {
        return 'success-row'
      }
      return ''
    },
    choicePlatform(val) {
      this.searchCondition.platform_code = val
      // console.log(this.searchCondition)
      this.initData()
    },
    async checkDetails(row) {
      if ((row.ad_artist_id || undefined) !== undefined) {
        const searchCondition = this.handleSearchCondition()
        if (searchCondition.months.length > 1) {
          this.$message.warning('暂不支持季度查询!')
          return false
        }
        this.drawerTableData = await this.$api.getRevenueOrderDetails({
          artist_id: row.ad_artist_id,
          month: searchCondition.months[0],
          year: searchCondition.year
        })
        this.drawerTitle = `${row.nickname + '的订单详情-' + searchCondition.year + '年' + searchCondition.months[0] + '月'}`
        this.drawerVisible = true
      } else this.$message.warning('未在系统比对到红人!')
    },
    async getPlatforms() {
      //从缓存中读取上次的平台信息
      const platformsJson = localStorage.getItem('platforms')
      if (platformsJson && platformsJson.indexOf('{') > -1) {
        this.platforms = JSON.parse(platformsJson)
      }

      // 获取最新平台信息
      const { list } = await this.$api.getPlatforms()
      this.platforms = list
      // 缓存平台信息
      localStorage.setItem('platforms', JSON.stringify(list))

    },
    getLastMonth() {
      this.ym = this.$utils.getLastMonth()
      const ymArr = this.ym.split('-')
      this.searchCondition.year = ymArr[0] * 1//年份
      this.searchCondition.months = [(ymArr[1]) * 1]//月份的集合
    },
    async initData() {
      this.tableData = []
      const searchCondition = this.handleSearchCondition()
      if (searchCondition.year) {
        // Object.assign(searchCondition, {})
        this.loading = true
        //已录入的数据
        const { list, in_company } = await this.$api.getRevenueDatumRankData(searchCondition)
        this.tableData = list
        this.in_company = in_company
        this.loading = false
      }
    },
    // 处理搜索条件
    handleSearchCondition() {
      const condition = {}
      this.conditionStr = ''
      const conditionArr = []
      if (this.searchCondition.depth) {
        condition.depth = this.searchCondition.depth
      }
      // if (this.searchCondition.group_id) {
      //   condition.group_id = this.searchCondition.group_id
      // }
      if (this.searchCondition.group_range) {
        condition.group_range = this.searchCondition.group_range
      }

      if (this.searchCondition.platform_code) {
        condition.platform_code = this.searchCondition.platform_code
        const platform = this.platforms.find((platform) => {
          if (platform.code === condition.platform_code)
            return platform
        })
        conditionArr.push('【' + platform.name + '】')
      } else {
        conditionArr.push('【全平台】')
      }

      if (this.searchCondition.year) {
        condition.year = this.searchCondition.year
        conditionArr.push('【' + condition.year + '年】')
      }

      if (this.searchCondition.months.length > 0) {
        condition.months = this.searchCondition.months
        conditionArr.push('【' + condition.months.join('月、') + '月】')
        // this.conditionStr += '  月份：【' + condition.months.join('、') + '】';
      }

      this.conditionStr = conditionArr.join(' ')

      return condition
    },
    selectDept(nodeIds) {
      // console.log(nodeIds)
      // const nodeData = this.$refs['refCompanySelect'].getNodeData()
      // console.log('=========== nodeData ==========')
      // console.log(nodeData)
      // nodeIds.forEach((_nodeId) => {
      //   let curr_node = nodeData.find(value => value.dpt_id === _nodeId)
      //   console.log(`node:${_nodeId},name:${curr_node.name}`)
      // })
      // console.log('=========== user allow dept ==========')
      // console.log(this.userDptInfo)
      // this.searchCondition.group_ids = nodeIds
      // this.filterGroups = val || []
      this.searchCondition.group_range = nodeIds
      this.initData()
    },
    changeMonth() {
      this.rangYm = null
      this.year = null
      if (this.ym && this.ym.indexOf('-') > -1) {
        const ymArr = this.ym.split('-')
        this.searchCondition.year = ymArr[0] * 1//年份
        this.searchCondition.months = [(ymArr[1]) * 1]//月份的集合
      } else {
        this.searchCondition.year = null
        this.searchCondition.months = []
      }
      this.initData()
    },
    choiceQuarter() {
      this.searchCondition.months = [1, 2, 3]//月份的集合
    },
    changeYear() {
      this.ym = null
      this.rangYm = []
      this.quarter = {}
      this.searchCondition.year = this.year
      this.searchCondition.months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]//月份的集合
      this.initData()
    },
    changeQuarter() {
      this.rangYm = []
      this.ym = null
      this.searchCondition.months = this.quarter.value//月份的集合
      this.initData()
    },
    async exportExcel() {
      try {
        const searchCondition = this.handleSearchCondition()
        const response = await this.$api.downloadRevenueDatum(searchCondition)
        let name = '营收数据'
        if (this.conditionStr) {
          name += `:${this.conditionStr}`
        }
        if (this.$refs['refExportLink'])
          this.$refs['refExportLink'].exportSaveXlsx(response, name)
      } catch (e) {
        this.$message.warning('导出异常，请联系管理员')
      }
    },
    async exportDownload() {
      try {
        const isFileSaverSupported = !!new Blob
        if (isFileSaverSupported) {
          const searchCondition = this.handleSearchCondition()
          const response = await this.$api.downloadRevenueDatum(searchCondition)
          const data = response.data
          const contentType = response.headers['content-type']
          let name = '营收数据'
          if (this.conditionStr) {
            name += `:${this.conditionStr}`
          }

          const blob = new Blob([data], {
            type: contentType
          })
          FileSaver.saveAs(blob, decodeURI(name + '.xlsx'), { autoBom: true })
        } else {
          this.$message.warning('浏览器不支持导出文件')
        }
      } catch (e) {
        this.$message.warning('导出异常，请联系管理员')
        // alert(JSON.stringify(e))
      }

    },
    async shareRank() {
      // Saving a canvas
      FileSaver.saveAs('https://httpbin.org/image', 'image.jpg')

    },
    goTrendDataList() {
      this.$router.push({
        name: 'revenue_enter'
      })
    },
    moneyFormat(value) {
      return numberFormat(value, 0, '.', ',', 'round')
    },
    getSummaries(param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index < 2) {
          return
        }
        if (index === 2) {
          sums[index] = '合计:'
          return
        }
        if (['income_total', 'income_1', 'order_money', 'income_2','income_8', 'income_3', 'income_4', 'income_5', 'income_7', 'income_balance'].indexOf(column.property) > -1) {
          const values = data.map(item => Number(item[column.property]))
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr)
              if (!isNaN(value)) {
                return prev * 1 + curr * 1
              } else {
                return prev
              }
            }, 0)
            sums[index] += ''
          } else {
            sums[index] = 'N/A'
          }
          // 格式化数据
          switch (column.property) {
            default:
              sums[index] = this.moneyFormat(sums[index])
              break
          }
        }
      })

      return sums
    },
    jumpToDetail(row) {
      const keyword = 'DingTalk'
      if (navigator.userAgent.indexOf(keyword) > -1) {
        // 获取订单配置
        this.$router.push({
          name: 'artist_trend_chart',
          params: { artist_id: row.artist_id },
          query: { group_name: row.group_name }
        })
      } else {
        const { href } = this.$router.resolve({
          name: 'artist_trend_chart',
          params: { artist_id: row.artist_id },
          query: { group_name: row.group_name }
        })
        window.open(href, '_blank')
      }
    },
    goDeptDetail(id) {
      if (id) {
        const { href } = this.$router.resolve({
          name: 'team',
          query: { group_id: id }
        })
        window.open(href, '_blank')
      } else {
        this.$notify.error('部门ID未知，无法查看详情')
      }
    },
    jumpToKolDetail(artist_id) {
      const { href } = this.$router.resolve({
        name: 'artist_intro',
        params: { artist_id: artist_id }
      })
      window.open(href, '_blank')
    }
  }
}
</script>

<style scoped>
::v-deep .el-form-item--small.el-form-item{
  margin-bottom: 2px;
}
.export-excel, .share-rank {
  margin-top: 20px;
  margin-right: 20px;
  margin-bottom: 1px;
  font-size: 16px;
  font-weight: 600;
}

.alert {
  padding: 10px; /* 内边距 */
  margin-bottom: 15px; /* 下边距 */
  border: 1px solid transparent; /* 边框 */
  border-radius: 4px; /* 边框圆角 */
}

.alert-warning {
  //color: #856404; /* 文字颜色 */
  background-color: #fff3cd; /* 背景颜色 */
  border-color: #ffeeba; /* 边框颜色 */
}

</style>

<style>
.el-table .warning-row {
  //color: #856404; /* 文字颜色 */
  background-color: #fff3cd; /* 背景颜色 */
  border-color: #ffeeba; /* 边框颜色 */
}

</style>
